<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('detailDemandeImpression.campagne.title')}}</p>
      </header>
      <div class="card-content is-flex is-justify-content-space-between">
        <b-field :label="$t('detailDemandeImpression.campagne.title')"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            <router-link-blank
              v-if="demandeImpression.campagneId"
              :to="{
                name: 'c.bodac.campagne',
                params: {
                  id: demandeImpression.campagneId,
                }
              }"
              class="lien"
              :message="getCampagneLibelle">
            </router-link-blank>
          </span>
        </b-field>
        <div>
          <qd-button
            @click="checkPermMajForCampagne
              ? actionAddCampagne()
              : showPopUp()"
            :class="[
              {'button-access-no-permission': !checkPermMajForCampagne},
              {'pointer-events-none': !checkPermMajForCampagne},
            ]"
            class="button is-primary">
            {{ $t('detailDemandeImpression.actions.addCampagne')}}
          </qd-button>
        </div>
      </div>
    </div>
    <div class="mgt-20px" v-if="demandeImpression.campagneId">
      <ligne-commande-attachement
        :id="demandeImpression.campagneId"
        :context="constantes.module"
        :libelleImage="$t('detailDemandeImpression.campagne.libelleLogo',
            { name: demandeImpression.campagne.libelle })"
        :permissions="constantes.CAMPAGNE.lecture"
        :resizeFile="false"
        :isFullWidth="true"
        :readOnly="true"
        :withToolTip="false">
      </ligne-commande-attachement>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import ligneCommandeAttachement from '@/components/commande/logistique/ligneCommandeAttachement';
import { SET_DEMANDE_IMPRESSION } from '@/store/modules/logistique/demandeImpression-mutation-type';
import { DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import { MODULE_CAMPAGNE } from '@/configuration/general/pieceJointeConf';
import { CAMPAGNE } from '@/configuration/permissionsBodacConf';

const DemandeImpression = createNamespacedHelpers('demandeImpression');
const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    demandeImpression: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        module: MODULE_CAMPAGNE,
        CAMPAGNE,
      },
    };
  },
  components: {
    RouterLinkBlank,
    ligneCommandeAttachement,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    checkPermMajForCampagne() {
      return this.checkPermissions(DEMANDE_IMPRESSION.maj) && this.checkPermissions(CAMPAGNE.maj);
    },
    getCampagneLibelle() {
      return this.demandeImpression.campagne?.libelle;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...DemandeImpression.mapMutations({
      setDemandeImpression: SET_DEMANDE_IMPRESSION,
    }),
    actionAddCampagne() {
      this.setDemandeImpression(this.demandeImpression);
      this.$router.push({ name: 'm.bodac.campagne-add' });
    },
  },
};
</script>

<style>

</style>
